export default __webpack_public_path__ + "static/hero_cloud_top-38149b496ed2e8dc430805b7d6abcdbd.png";